<div class="d-flex align-items-center justify-content-center me-2 mb-2 img-thumbnail">
  <div class="spinner-wrapper d-flex align-items-center justify-content-center" *ngIf="isLoading">
    <div class="spinner-border spinner text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div *ngIf="!isLoading" (click)="open()" class="cursor-pointer">
    <div class="img" [style.background-image]="'url(' + imgBase64  + ')'"></div>
  </div>
</div>

